import { type ComputedRef, computed } from "vue";
import { useRoute } from "./useRoute";

export function useHomepage() {
  const { path } = useRoute();

  const multiLangPaths = new Set([
    "/nl-BE/",
    "/fr-BE/",
    "/de-LU/",
    "/fr-LU/",
    "/fr-CH/",
    "/it-CH/",
    "/de-CH/",
    "/et-EE/",
    "/ru-EE/",
    "/ru-LV/",
    "/lv-LV/",
    "/en-CY/",
    "/el-CY/",
  ]);

  const isHomepage: ComputedRef<boolean> = computed(() => {
    if (path.value === "/") {
      return true;
    }
    return multiLangPaths.has(path.value);
  });

  return {
    isHomepage,
  };
}
